/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

// Images
// import appleLogo from "assets/images/logos/gray-logos/logo-apple.svg";
// import facebookLogo from "assets/images/logos/gray-logos/logo-facebook.svg";
// import nasaLogo from "assets/images/logos/gray-logos/logo-nasa.svg";
// import vodafoneLogo from "assets/images/logos/gray-logos/logo-vodafone.svg";
// import digitalOceanLogo from "assets/images/logos/gray-logos/logo-digitalocean.svg";

function Information() {
  return (
    <MKBox component="section" py={6}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          justifyContent="center"
          sx={{ mx: "auto", textAlign: "center", mb: 2 }}
        >
          <MKTypography variant="h2">Quick Links</MKTypography>
        </Grid>
        <Grid container spacing={3} sx={{ mt: 4 }}>
          <Grid item xs={12} md={6} lg={4}>
            <FilledInfoCard
              //variant="gradient"
              color="info"
              icon="info"
              title="Register To VOTE"
              //description="2025-2026 Budget Estimate presented to the Special Committee of the House of Assembly."
              action={{
                type: "internal",
                route: "/voters",
                label: "View",
              }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <FilledInfoCard
              //variant="gradient"
              color="info"
              icon="info"
              title="Where Do I VOTE"
              //description="2025-2026 Budget Estimate presented to the Special Committee of the House of Assembly."
              action={{
                type: "internal",
                route: "https://enstools.electionsnovascotia.ca/edinfo_wdiv/Location.aspx",
                label: "View",
              }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <FilledInfoCard
              color="info"
              icon="info"
              title="News/ Media Room"
              action={{
                type: "internal",
                route: "/news",
                label: "View",
              }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <FilledInfoCard
              //variant="gradient"
              color="info"
              icon="info"
              title="Contact Information"
              //description="2025-2026 Budget Estimate presented to the Special Committee of the House of Assembly."
              action={{
                type: "internal",
                route: "/contact-us",
                label: "View",
              }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <FilledInfoCard
              //variant="gradient"
              color="info"
              icon="info"
              title="Electoral District Information"
              //description="2025-2026 Budget Estimate presented to the Special Committee of the House of Assembly."
              action={{
                type: "external",
                route: "https://enstools.electionsnovascotia.ca/edinfo/",
                label: "View",
              }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <FilledInfoCard
              color="info"
              icon="info"
              title="Past Election Results And Statistics"
              action={{
                type: "internal",
                route: "/past-election-results",
                label: "View",
              }}
            />
          </Grid>
          {/* <Grid item xs={12} md={6} lg={4}>
            <FilledInfoCard
              //variant="gradient"
              color="info"
              icon="info"
              title="2024 General Election Results Map"
              action={{
                type: "external",
                route: "https://electionsnovascotia.ca/files/2024ResultsMap.pdf",
                label: "View",
              }}
            />
          </Grid> */}
          <Grid item xs={12} md={6} lg={4}>
            <FilledInfoCard
              //variant="gradient"
              color="info"
              icon="info"
              title="Chief Electoral Officer"
              action={{
                type: "internal",
                route: "/about-us",
                label: "View",
              }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <FilledInfoCard
              // //variant="gradient"
              color="info"
              icon="info"
              title="Official Results Provincial General Election 2024"
              //description="2025-2026 Budget Estimate presented to the Special Committee of the House of Assembly."
              action={{
                type: "external",
                route: "https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Felectionsnovascotia.ca%2Ffiles%2FGeneralElection_42nd%2F42PGE_PollbyPoll_AllEDs_TurnOut_FINAL.xlsx&wdOrigin=BROWSELINK",
                label: "View",
              }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <FilledInfoCard
              color="info"
              icon="info"
              title="Distribution Of Seats By Political Party Map, 2026 (PDF Map)"
              action={{
                type: "external",
                route: "/files/ElectoralDistrictMapInformation/DistributionOfSeatsByParty_2026_05.pdf",
                label: "View",
              }}
            />
          </Grid>
        </Grid>
        <Divider sx={{ my: 4 }} />
      </Container>
    </MKBox>
  );
}

export default Information;
